import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilesService {


  constructor() { }

  getBase64Image(file: File, resize?: boolean): Promise<string> {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve, reject) => {
      reader.onload = (event) => {
        let img = new Image();
        img.src = event.target!.result!.toString();

        img.onload = () => {
          let resizeFactor = 1;
          if (resize) {
            if (img.width >= img.height) {
              resizeFactor = 300 / img.width;
            } else {
              resizeFactor = 300 / img.height;
            }
          }

          const canvas = document.createElement('canvas');
          canvas.width = img.width * resizeFactor;
          canvas.height = img.height * resizeFactor;

          const ctx = canvas.getContext('2d')!;
          // source image, left X coord, up Y coord, right X coord, down Y coord
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          resolve(canvas.toDataURL().split(',')[1]);
        }
      }
    })
  }

  getBase64File(file: File): Promise<string> {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        let base64 = reader.result as string;
        resolve(base64.split(',')[1]);
      }
    })
  }

  getFileExtension(filename: string): string {
    return filename.split('.').pop() || '';
  }

  getFileName(filename: string): string {
    let temp = filename.split('/');
    let fullFilename = temp.pop()!; // filename + extension
    temp = fullFilename.split('.');
    temp.pop();
    return decodeURI(temp.join('.'));
  }

  getFileIconClass(extension: string): string {
    switch (extension) {
      case "xlsx":
      case "xls":
        return "far fa-file-excel";
      case "csv":
        return "fas fa-file-csv";
      case "pdf":
        return "far fa-file-pdf";
      case "doc":
      case "docx":
      case "odt":
        return "far fa-file-word";
      case "ppt":
      case "pptx":
        return "far fa-file-powerpoint";
      default:
        return "far fa-file";
    }
  }

  getImgSrc(image: string): string {
    if (image&&image.startsWith('blob')) {
      return image
    }
    return image
  }
}
